import { render, staticRenderFns } from "./customIconsDialog.vue?vue&type=template&id=404f1344&"
import script from "./customIconsDialog.vue?vue&type=script&lang=js&"
export * from "./customIconsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports